import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/logo.png" alt="DHRTI MAA" className="footer-logo-img" />
              <div className="footer-logo-text">
                <h3 className="footer-title">DHRTI MAA</h3>
                <p className="footer-tagline">Inspired By Nature</p>
              </div>
            </div>
            <p className="footer-description">
              Your trusted partner for quality gardening needs. We provide natural solutions for your gardens & farms.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/about" className="footer-link">About Us</Link></li>
              <li><Link to="/products" className="footer-link">Products</Link></li>
              <li><Link to="/blog" className="footer-link">Blog</Link></li>
              <li><Link to="/contact" className="footer-link">Contact</Link></li>
            </ul>
          </div>


          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-heading">Contact Info</h4>
            <div className="footer-contact">
              <p className="footer-contact-item">
                <span className="contact-icon">📞</span>
                <span>+91 8890060211</span>
              </p>
              <p className="footer-contact-item">
                <span className="contact-icon">✉️</span>
                <span>DhrtiMaaOrganics@gmail.com</span>
              </p>
              <p className="footer-contact-item">
                <span className="contact-icon">📍</span>
                <span>Balaji Vihar-29, VKIA, Jaipur-302013</span>
              </p>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              © {new Date().getFullYear()} DHRTI MAA. All rights reserved.
            </p>
            <div className="footer-legal">
              <Link to="/privacy-policy" className="footer-legal-link">Privacy Policy</Link>
              <Link to="/terms-of-service" className="footer-legal-link">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
